<template>
  <div class="wetec-history">
    <table>
      <thead>
        <tr>
          <th>No.</th>
          <th>Wetec</th>
          <th>Total score</th>
          <th>1st section</th>
          <th>2nd section</th>
          <th>3rd section</th>
          <th>4th section</th>
          <th>5th section</th>
          <th>6th section</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="history of histories" :key="history.no">
          <td>{{history.no}}</td>
          <td>{{history.name}}</td>
          <td>{{history.wetec.total | formatdec}}</td>
          <td>{{history.wetec.first | formatdec}}</td>
          <td>{{history.wetec.second | formatdec}}</td>
          <td>{{history.wetec.third | formatdec}}</td>
          <td>{{history.wetec.fourth | formatdec}}</td>
          <td>{{history.wetec.fifth | formatdec}}</td>
          <td>{{history.wetec.sixth | formatdec}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang='ts'>
import { Vue, Prop, Component } from 'vue-property-decorator';
import { WetecHistory } from '@/store/students/types';

@Component({
  filters: {
    formatdec(v: string|null): string {
      if (!v) return ''
      return parseFloat(v).toFixed(2)
    },
  },
})

export default class StudentWetecHistory extends Vue {
  @Prop() histories!: WetecHistory[]
}
</script>
<style scoped>
.wetec-history {
  height: 420px;
  overflow-y: scroll;
}

table {
  width:100%;
  border-collapse:collapse;
  background: #fff;
  margin-bottom:10px;
}

table thead th, table thead td {
  padding: 20px;
}

table tbody tr:nth-child(odd) {
  background: #D8D8D8;
}

table th {
  padding:10px;
  text-align: center;
  background-color: #fff;
  position: sticky;
  top: 0;
  border-top:#fff;
}
th:before{
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border-top: 2px solid #DBDBDB;
  border-bottom: 2px solid #DBDBDB;
}
th:first-child:before {
  border-left: 2px solid #DBDBDB;
}
th:last-child:before {
  border-right: 2px solid #DBDBDB;
}

table td {
  height: 50px;
  padding:5px 10px;
  text-align: center;
}

</style>
